import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden py-20 px-4 sm:px-6 lg:px-8 bg-navy-950" data-id="element-89" data-mp="2hvm2a25rra8j">
      {/* Background subtle glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-900/20 rounded-full blur-[120px] pointer-events-none" data-id="element-90" data-mp="28tctphu29qxs" />

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-91" data-mp="2wm36tudpag9n">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center lg:text-left" data-id="element-92" data-mp="2mtxgep33k6wk">
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.3,
          duration: 0.8
        }} className="inline-block mb-4 px-4 py-1.5 rounded-full border border-gold-500/30 bg-gold-500/10 text-gold-300 text-sm font-medium tracking-wide uppercase" data-id="element-93" data-mp="3k9ba66rkjf91">
            La Guía Que Los Afiliados Exitosos Desearían Haber Tenido Desde El
            Día Uno
          </motion.div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white" data-id="element-94" data-mp="2z26ix4mrp74c">
            El Sistema Exacto Que Usan Los Afiliados Que Sí Ganan Para{' '}
            <span className="text-gold-400 text-glow" data-id="element-95" data-mp="384ftfui1d0hq">
              Convertir Seguidores en Comisiones
            </span>
          </h1>

          <p className="text-lg sm:text-xl text-slate-300 mb-10 max-w-2xl mx-auto lg:mx-0 font-light" data-id="element-96" data-mp="335mhw7mb7jk7">
            Sin Invertir en Ads Ni Tener Miles de Seguidores.
          </p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6,
          duration: 0.8
        }} className="flex flex-col items-center lg:items-start space-y-4" data-id="element-97" data-mp="18sddgu8meo8t">
            <div className="flex items-center justify-center lg:justify-start space-x-3 mb-3" data-id="element-98" data-mp="3mtm2cxt9nraq">
              <span className="text-slate-500 line-through text-lg" data-id="element-99" data-mp="3rsp8klkzg3ka">
                $17.99
              </span>
              <span className="text-4xl font-black text-gold-400 text-glow" data-id="element-100" data-mp="l4dqcg5kgs4">
                $6.36{' '}
                <span className="text-base font-medium text-gold-300" data-id="element-101" data-mp="5dnpd3va51ua">USD</span>
              </span>
            </div>
            <button className="w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-gold-500 to-gold-400 hover:from-gold-400 hover:to-gold-300 text-navy-950 font-bold text-lg rounded-lg shadow-[0_0_20px_rgba(212,175,55,0.4)] hover:shadow-[0_0_30px_rgba(212,175,55,0.6)] transition-all duration-300 transform hover:-translate-y-1" data-id="element-102" data-mp="ab608zsuxr4x">
              Quiero El Sistema Completo
            </button>
            <div className="flex items-center text-sm text-slate-400 space-x-2" data-id="element-103" data-mp="1yujy3bknz769">
              <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-104" data-mp="1usyel7dmjun3" />
              <span data-id="element-105" data-mp="1uvkt5qyxnaet">Garantía de satisfacción total · Acceso inmediato</span>
            </div>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        rotateY: -15
      }} animate={{
        opacity: 1,
        scale: 1,
        rotateY: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-md lg:max-w-full perspective-1000" data-id="element-106" data-mp="2ml5u24he90zw">
          <div className="relative transform-gpu hover:rotate-y-12 transition-transform duration-700 ease-out" data-id="element-107" data-mp="369op32p2z8mi">
            <div className="absolute inset-0 bg-gold-500/20 blur-2xl rounded-3xl transform -rotate-6 scale-105" data-id="element-108" data-mp="31glucr8kht4q" />
            <img src="https://cdn.magicpatterns.com/uploads/nfCS2tLa6bNu9eozKZeLuT/cober2.png" alt="Secretos de Promoción Book Cover" className="relative z-10 w-full h-auto rounded-lg shadow-2xl border border-white/10" data-id="element-109" data-mp="2l4s3a7c70jr5" />
          </div>
        </motion.div>
      </div>
    </section>;
}